import { useLayoutEffect } from "react";

import { useActivationLoadingScreenStore } from "./activationLoadingScreenStore";

export const useActivationLoadingScreenState = () => {
  const isVisible = useActivationLoadingScreenStore(state => state.isVisible);
  const start = useActivationLoadingScreenStore(state => state.start);
  const clear = useActivationLoadingScreenStore(state => state.clear);

  return {
    clear,
    isVisible,
    start,
  };
};

export const useClearCircleAIActivationLoadingState = () => {
  const isVisible = useActivationLoadingScreenStore(state => state.isVisible);
  const clear = useActivationLoadingScreenStore(state => state.clear);

  useLayoutEffect(() => {
    if (isVisible) {
      clear();
    }
  }, [clear, isVisible]);
};
